<template>
  <div>
    <block-title class="block-title" title="收货地站点信息">
      <a-form-model
        class="form-content choose-type"
        :model="form"
        layout="inline"
      >
        <a-form-model-item :colon="false" label="收货地导入方式(三选一)" prop="type">
          <a-radio-group
            v-model="form.importType"
            class="radio-global"
            @change="changeRadio"
          >
            <a-radio
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
            >{{item.label}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <form-item
        ref="receivingForms"
        form-fef="receivingInfo"
        :form="form"
        :rules="rules"
        v-bind="$attrs"
        :field-list="fieldList[form.importType]"
        @change="changeInfo"
      />
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import FormItem from './FormItem.vue'
import { RECEIVINGFIELDLIST, RECEIVINGTYPELIST, RECEIVINGRULES } from '../constant'

export default {
  name: 'ReceivingInfo',
  components: {
    BlockTitle,
    FormItem
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: RECEIVINGRULES,
      fieldList: RECEIVINGFIELDLIST,
      typeList: RECEIVINGTYPELIST,
    }
  },
  methods: {
    // 切换导入选项时需重新校验是否填写完整
    changeRadio() {
      this.$emit('changeFiled')
      this.$nextTick(() => {
        this.getValidate()
      })
    },
    getValidate() {
      this.$refs.receivingForms.changeInfo()
    },
    changeInfo(valid) {
      this.$emit('change', valid, this.index)
    }
  }
}
</script>